import { sample } from "lodash";

export function getRandomGameId({ games }) {
    const randomGame = sample(games);
    return randomGame?.id ? randomGame.id : '';
}